import React from 'react';
export function Stats() {
  const stats = [{
    value: '+300',
    label: 'Triatletas confían'
  }, {
    value: '6HS',
    label: 'por semana'
  }, {
    value: '4.9/5',
    label: 'Calificación ⭐'
  }, {
    value: '🇦🇷',
    label: 'Todo el país'
  }];
  return <section className="bg-black border-y border-white/10 py-12" data-id="element-109">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x-0 md:divide-x divide-white/10" data-id="element-111">
          {stats.map((stat, index) => <div key={index} className="flex flex-col items-center justify-center text-center px-4" data-id="element-112">
              <div className="font-serif text-4xl md:text-5xl font-bold text-brand-green mb-2" data-id="element-113">
                {stat.value}
              </div>
              <div className="text-sm font-bold tracking-widest text-white/60 uppercase" data-id="element-114">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}